import { CenterPos, DetailsButton, ResultsColumn, Row, TitleWrapper } from './DTRbiChallengeWidget.styles';
import React from 'react';
import { COLUMN_WIDTH } from './ChallengeTable';
import { ChallengeTimeline } from 'components/DecisionTree/DTInfoWidget/RBI/DTRbiChallengeWidget/ChallengeTimeline';
import { mergeChallengeStepsAndCompletions } from './DTRbiChallengeWidgetUtils';

const dateOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZoneName: 'short',
};

export const ChallengeItem = ({ challenge, selectedChallengeId, handleChangeSelectedChallengeId }) => {
  const isChallengeOpen = challenge.id === selectedChallengeId;
  const toggleSelectedChallengeId = () => {
    handleChangeSelectedChallengeId(challenge.id);
  };

  const startDateFormatted = new Date(challenge.startDate).toLocaleString('en-US', dateOptions);
  const endDateFormatted = new Date(challenge.endDate).toLocaleString('en-US', dateOptions);

  /** NOTE(apoorvyadav1|SPD-12512|2025-06-16): Since the challenge steps are optional,
   * we need to check if they exist.
   */
  const { steps = [] } = challenge;

  const showSteps = steps.some((step) => {
    const { minimumSpend, cartRequirements } = step || {};

    return !!minimumSpend || cartRequirements?.some((item) => item.length > 0);
  });

  /** NOTE(apoorvyadav1|SPD-12512|2025-06-16): Utilizing the progress or completions
   * to determine the challenge's completion steps ( based on the BK backend tool)
   */
  const { progress, completions } = challenge;

  const completionsSteps = progress || completions?.[0] || {};

  const { activatedOn, steps: challengeCompletionsSteps = [] } = completionsSteps;

  const activityStatus = activatedOn ? 'Active' : 'Inactive';

  const formattedStepsWithCompletions = mergeChallengeStepsAndCompletions(steps, challengeCompletionsSteps);

  const countCompletedSteps = formattedStepsWithCompletions.filter((step) => step.completedAt).length;

  return (
    <>
      <Row open={isChallengeOpen}>
        <ResultsColumn $width={COLUMN_WIDTH.name}>{challenge.name}</ResultsColumn>
        <ResultsColumn $width={COLUMN_WIDTH.date}>{startDateFormatted}</ResultsColumn>
        <ResultsColumn $width={COLUMN_WIDTH.date}>{endDateFormatted}</ResultsColumn>
        <ResultsColumn $width={COLUMN_WIDTH.active} $justifyContent={'center'}>
          <TitleWrapper>{activityStatus}</TitleWrapper>
        </ResultsColumn>
        <ResultsColumn $width={COLUMN_WIDTH.incentive}>
          <TitleWrapper>{challenge.incentiveType}</TitleWrapper>
        </ResultsColumn>
        <ResultsColumn $width={COLUMN_WIDTH.details}>
          <CenterPos>
            <strong>{showSteps ? `${countCompletedSteps}/${formattedStepsWithCompletions.length} ` : 'N/A '}</strong>
            <DetailsButton
              open={isChallengeOpen}
              onClick={() => toggleSelectedChallengeId()}
              data-testID={'details-btn'}
            />
          </CenterPos>
        </ResultsColumn>
      </Row>
      {isChallengeOpen && showSteps && (
        <>
          <ChallengeTimeline steps={formattedStepsWithCompletions} />
        </>
      )}
    </>
  );
};
